module.exports = __webpack_public_path__ + "static/img/login-background.34fb5e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/login-background.png
// module id = eZuA
// module chunks = 0